import PropTypes from "prop-types";
import styles from "./styles.module.scss"; // Optional: use SASS modules for styling

const Pagination = ({
  totalItems,
  currentPage,
  onPageChange,
  hasMorePages,
  itemsPerPage = 16,
  maxVisiblePages = 5,
}) => {
  const totalPages = Math.ceil(totalItems / itemsPerPage);

  const getPageNumbers = () => {
    const visiblePages = [];
    let startPage = Math.max(1, currentPage - Math.floor(maxVisiblePages / 2));
    const endPage = Math.min(totalPages, startPage + maxVisiblePages - 1);

    // Adjust startPage if near the end
    if (endPage - startPage < maxVisiblePages - 1) {
      startPage = Math.max(1, endPage - maxVisiblePages + 1);
    }

    for (let i = startPage; i <= endPage; i++) {
      visiblePages.push(i);
    }
    return visiblePages;
  };

  const handlePageChange = (page) => {
    if (page !== currentPage && page >= 1 && page <= totalPages) {
      onPageChange(page);
    }
  };

  const visiblePages = getPageNumbers();

  return (
    <div className={styles.pagination}>
      {/* Previous Button */}
      <button
className={`${styles.paginationBtn} ${styles.prevBtn}`}
onClick={() => handlePageChange(currentPage - 1)}
        disabled={currentPage === 1}
      >
      
      </button>

      {/* First Page Button */}
      {visiblePages[0] !== 1 && (
        <>
          <button
            className={styles.paginationBtn}
            onClick={() => handlePageChange(1)}
          >
            1
          </button>
          {visiblePages[0] > 2 && (
            <span className={styles.paginationEllipsis}>...</span>
          )}
        </>
      )}

      {/* Dynamic Page Numbers */}
      {visiblePages.map((page) => (
        <button
          key={page}
          className={`${styles.paginationBtn} ${
            currentPage === page ? styles.active : ""
          }`}
          onClick={() => handlePageChange(page)}
        >
          {page}
        </button>
      ))}

      {/* Last Page Button */}
      {visiblePages[visiblePages.length - 1] !== totalPages && (
        <>
          {visiblePages[visiblePages.length - 1] < totalPages - 1 && (
            <span className={styles.paginationEllipsis}>...</span>
          )}
          <button
            className={styles.paginationBtn}
            onClick={() => handlePageChange(totalPages)}
          >
            {totalPages}
          </button>
        </>
      )}

      {/* Next Button */}
      <button
className={`${styles.paginationBtn} ${styles.nextBtn}`}
onClick={() => handlePageChange(currentPage + 1)}
        disabled={currentPage === totalPages || !hasMorePages}
      >
      </button>
    </div>
  );
};

Pagination.propTypes = {
  totalItems: PropTypes.number.isRequired,
  itemsPerPage: PropTypes.number.isRequired,
  currentPage: PropTypes.number.isRequired,
  onPageChange: PropTypes.func.isRequired,
  maxVisiblePages: PropTypes.number,
  hasMorePages: PropTypes.bool.isRequired, // Added prop for disabling Next button
};

export default Pagination;
